<script>
	import { goto } from '$app/navigation';
	if (typeof window !== 'undefined') goto('onboard/track');
</script>
